import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getAcademicYearsList,
  getClassesList,
  getMigrationsList,
  postNewClasses,
} from '../../features/history/HistorySlice';
import {
  Button,
  Card,
  Chip,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import ModalDialog from '../UIElements/ModalDialog';
import EastIcon from '@mui/icons-material/East';
import { MenuProps } from '../../utils/constants';
import VisibilityIcon from '@mui/icons-material/Visibility';
import useNotification from '../../hooks/useNotification';
import ToastNotification from '../UIElements/ToastNotification';
function MigrationTab() {
  const [openModal, setOpenModal] = useState(false);
  const [migrationsData, setMigrationsData] = useState([]);
  const [classesList, setClassesList] = useState([]);
  const [loading, setLoading] = useState([]);
  const [error, setError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [academicYearCode, setAcademicYearCode] = useState('');
  const dispatch = useDispatch();
  const [academicYearsList, setAcademicYearsList] = useState([]);
  async function getClassesMigrationDetails() {
    setLoading(true);
    try {
      const [res1, res2] = await Promise.all([
        dispatch(getClassesList()).unwrap(),
        dispatch(getMigrationsList()).unwrap(),
      ]);
      setClassesList(res1.data);
      setMigrationsData(res2.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }
  function handleSubmit() {
    if (academicYearCode) {
      setOpenModal(true);
      setError(false);
    } else {
      setError(true);
    }
  }
  async function getAcademicYears() {
    setLoading(true);
    try {
      const response = await dispatch(getAcademicYearsList()).unwrap();
      if (response.status === 200) {
        setAcademicYearsList(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }
  const { notification, showSuccess, showError, hideNotification } =
    useNotification();
  useEffect(() => {
    getClassesMigrationDetails();
    getAcademicYears();
  }, []);
  return (
    <>
      <Card className='max-w-5xl px-4 py-10 border-t min-h-64'>
        <Typography className='mb-2 text-xl font-bold text-red-600 animate-pulse '>
          ⚠️ IMPORTANT: Please check the migration details once more carefully!
        </Typography>
        <Typography variant='h6' className='mb-1 text-blue-600'>
          Class Migration
        </Typography>
        {/* Loading Status for Classes details */}
        {Object.keys(classesList)?.length == 0 && loading && (
          <Card className='flex flex-wrap items-center justify-center gap-4 mb-4 min-h-52'>
            <CircularProgress></CircularProgress>
            <Typography variant='body1'>
              Fectching the classes details...
            </Typography>
          </Card>
        )}
        {/*No data message for classes Details*/}
        {Object.keys(classesList)?.length == 0 && !loading && (
          <Card className='flex items-center justify-center gap-4 mb-4 min-h-52'>
            <Typography variant='body1'>
              No classes information found for migration.
            </Typography>
          </Card>
        )}
        <p>
          <p>
            <p></p>
          </p>
        </p>
        {/* Migration of Upcomming classes CurrentClass and NextClass */}
        {Object.keys(classesList)?.length > 0 && (
          <>
            <Card className='max-w-5xl p-4 overflow-auto border-t '>
              <div className='max-w-2xl overflow-auto min-w-96 max-h-80'>
                {Object.keys(classesList)?.map((obj, index) => (
                  <div
                    key={obj}
                    className='grid grid-cols-[1fr_max-content_1fr] items-baseline my-2'
                  >
                    <div className='flex gap-2 '>
                      <Typography variant='h6' className='mt-2'>
                        {`${index + 1} )`}
                      </Typography>
                      <Typography variant='h6' className='mt-2'>
                        {obj}
                      </Typography>
                    </div>
                    <Typography className='pr-10 mx-4 text-center '>
                      <EastIcon />
                    </Typography>
                    <Typography variant='h6' className='mt-2'>
                      {classesList[obj]}
                    </Typography>
                  </div>
                ))}
              </div>
              <div className='max-w-2xl'>
                <div className='flex flex-wrap justify-between my-3'>
                  <Typography variant='h6'>
                    Select Previous Academic Code
                    <span className='text-red-500'> *</span>
                  </Typography>
                  <FormControl
                    id='Code'
                    className='w-60'
                    fullWidth
                    size='small'
                    error={error}
                  >
                    <InputLabel>Select Academic Code</InputLabel>
                    <Select
                      id='Code'
                      MenuProps={MenuProps}
                      value={academicYearCode}
                      onChange={(e) => setAcademicYearCode(e.target.value)}
                      label='Select Academic Code'
                    >
                      <MenuItem value=''>Select Academic Code</MenuItem>
                      {academicYearsList?.map((obj) => (
                        <MenuItem key={obj.id} value={obj}>
                          {obj.code}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <Button
                  variant='contained'
                  className='block mt-4 ml-auto'
                  onClick={handleSubmit}
                >
                  Migrate
                </Button>
              </div>
            </Card>
          </>
        )}
        {/* dialog to check Migration Details Before Confirmation */}
        <ModalDialog
          size='sm'
          isOpen={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
        >
          <div>
            {' '}
            <Typography variant='h6' color='primary'>
              Classes Migration Details
            </Typography>
            <TableContainer
              component={Paper}
              variant='outlined'
              sx={{
                maxHeight: 300,
                overflow: 'auto',
              }}
            >
              <Table
                stickyHeader
                size='small'
                sx={{ minWidth: 200, maxHeight: 700 }}
              >
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                    <TableCell className='text-blue-600'>
                      <strong>SNO</strong>
                    </TableCell>
                    <TableCell className='text-blue-600'>
                      <strong>Current Class</strong>
                    </TableCell>
                    <TableCell className='text-blue-600'>
                      <strong>Migration</strong>
                    </TableCell>
                    <TableCell className='text-blue-600'>
                      <strong>New Class</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(classesList)?.map((obj, index) => (
                    <TableRow
                      key={obj}
                      hover
                      sx={{
                        '&:nth-of-type(odd)': {
                          backgroundColor: '#fafafa',
                        },
                      }}
                    >
                      <TableCell className='truncate max-w-[400px] '>
                        {index + 1}
                      </TableCell>
                      <TableCell className='truncate max-w-[400px] '>
                        {obj}
                      </TableCell>
                      <TableCell className='truncate max-w-[400px] '>
                        <EastIcon />
                      </TableCell>
                      <TableCell>{classesList[obj]}</TableCell>
                    </TableRow>
                  ))}{' '}
                </TableBody>
              </Table>
            </TableContainer>{' '}
            <Typography variant='h6' className='my-2'>
              Academic Year Code : {academicYearCode.code}
            </Typography>
            <div className='text-red-600'>
              <strong>Note :</strong>Please check the Migration of Classes once
              again, it can't be reversable.
            </div>
            <div className='mt-2 text-end'>
              <Button
                variant='outlined'
                color='error'
                onClick={() => setOpenModal(false)}
              >
                cancel
              </Button>
              <Button
                variant='contained'
                disabled={isSubmitting}
                color='success'
                className='ml-4'
                onClick={async () => {
                  setIsSubmitting(true);
                  try {
                    const resposne = await dispatch(
                      postNewClasses(academicYearCode?.id),
                    ).unwrap();
                    if (resposne?.data) {
                      showSuccess('Migration process started.');
                      setMigrationsData(resposne.data);
                      setOpenModal(false);
                      setAcademicYearCode('');
                      setTimeout(() => {
                        getClassesMigrationDetails();
                      }, 120000);
                    }
                  } catch (error) {
                    error.status === 409
                      ? showError(
                          'Invalid academic year code,please select the latest one.',
                        )
                      : showError('Error in Migration,Please check it once.');
                  } finally {
                    setIsSubmitting(false);
                  }
                }}
              >
                {isSubmitting ? 'Submiting...' : 'OK'}
              </Button>
            </div>
          </div>
        </ModalDialog>

        <Typography variant='h6' className='mt-3 mb-2 text-blue-600'>
          Migrations History
        </Typography>
        {/* Loading Status */}
        {migrationsData?.length == 0 && loading && (
          <Card className='flex flex-wrap items-center justify-center gap-4 border-t min-h-52'>
            <CircularProgress></CircularProgress>
            <Typography variant='body1'>
              Fetching the previous migrations detials ...
            </Typography>
          </Card>
        )}
        {/* No Data Messg */}
        {migrationsData?.length == 0 && !loading && (
          <Card className='flex items-center justify-center gap-4 border-t min-h-52'>
            <Typography variant='body1'>
              No previous migrations detials available
            </Typography>
          </Card>
        )}
        {/* Previous Migrations History Table Order-Wise */}
        {migrationsData?.length > 0 && (
          <TableContainer
            component={Paper}
            variant='outlined'
            sx={{
              maxHeight: 600,
              overflow: 'auto',
            }}
          >
            <Table stickyHeader size='small' sx={{ minWidth: 700 }}>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                  <TableCell className='text-blue-600'>
                    <strong>SNO</strong>
                  </TableCell>
                  <TableCell className='text-blue-600'>
                    <strong>Academic Year</strong>
                  </TableCell>
                  <TableCell className='text-blue-600'>
                    <strong>Migration Start</strong>
                  </TableCell>
                  <TableCell className='text-blue-600'>
                    <strong>Migration End</strong>
                  </TableCell>
                  <TableCell className='text-blue-600'>
                    <strong>Migrated By</strong>
                  </TableCell>
                  <TableCell className='text-blue-600'>
                    <strong>Status</strong>
                  </TableCell>
                  <TableCell className='text-blue-600'>
                    <strong>Details</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {migrationsData?.map((obj, index) => (
                  <TableRow
                    key={obj?.id}
                    hover
                    sx={{
                      '&:nth-of-type(odd)': {
                        backgroundColor: '#fafafa',
                      },
                    }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell className='truncate max-w-[400px] '>
                      {obj.academicYear}
                    </TableCell>
                    <TableCell className='truncate max-w-[400px] '>
                      {obj.startedAt}
                    </TableCell>
                    <TableCell className='truncate max-w-[400px] '>
                      {obj.completedAt ?? 'Pending...'}
                    </TableCell>
                    <TableCell className='truncate max-w-[400px] '>
                      {obj.createdBy}
                    </TableCell>
                    <TableCell className='truncate max-w-[400px] '>
                      {getStatus(obj.status)}
                    </TableCell>
                    <TableCell className='truncate max-w-[400px] '>
                      <OpenStatus statusObj={obj.process ?? {}} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Card>
      <ToastNotification
        open={notification.open}
        onClose={hideNotification}
        message={notification.message}
        title={notification.title}
        severity={notification.severity}
        autoHideDuration={notification.autoHideDuration}
        position={notification.position}
      />
    </>
  );
}
export default MigrationTab;
function getStatus(status) {
  if (!status) return '--';
  else if (status?.toLowerCase() == 'success')
    return <Chip color='success' label='success' />;
  else if (status?.toLowerCase() == 'failed')
    return <Chip color='error' label='Failed' />;
  else if (status?.toLowerCase() == 'running')
    return <Chip color='warning' label='Pending' />;
  else if (status?.toLowerCase() == 'pending')
    return <Chip color='warning' label='Pending' />;
}

export const OpenStatus = ({ statusObj }) => {
  const [open, setOpen] = useState(false);
  const dataObj = { ...statusObj };
  const isFailed = Object.keys(statusObj)?.find(
    (keyName) => statusObj[keyName].toLowerCase() === 'failed',
  );
  Object.keys(statusObj ?? [])?.forEach((key) => {
    if (key?.startsWith('code to')) {
      delete dataObj[key];
    }
  });

  return (
    <div>
      <VisibilityIcon onClick={() => setOpen(true)}></VisibilityIcon>
      <ModalDialog
        size='sm'
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <div>
          {' '}
          <Typography variant='h6' color='primary' className='mb-2'>
            Migration Process Status Details
          </Typography>
          {Object.keys(statusObj)?.length > 0 ? (
            <TableContainer
              component={Paper}
              variant='outlined'
              sx={{
                maxHeight: 700,
                overflow: 'auto',
              }}
            >
              <Table stickyHeader size='small' sx={{ minWidth: 200 }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                    <TableCell>
                      <strong>SNO</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Current </strong>
                    </TableCell>
                    <TableCell>
                      <strong>Migration</strong>
                    </TableCell>
                    <TableCell>
                      <strong>New Status</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(dataObj)?.map((key, index) => (
                    <TableRow
                      key={index}
                      hover
                      sx={{
                        '&:nth-of-type(odd)': {
                          backgroundColor: '#fafafa',
                        },
                      }}
                    >
                      <TableCell className='truncate max-w-[400px] '>
                        {index + 1}
                      </TableCell>
                      <TableCell className='truncate max-w-[400px] '>
                        {key.split(' to ')?.[0]}
                      </TableCell>
                      <TableCell className='truncate max-w-[400px] '>
                        {key?.split(' to ')?.[1]}
                      </TableCell>
                      <TableCell>{getStatus(dataObj[key])}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <div className='flex flex-col items-center justify-center gap-2'>
              <CircularProgress></CircularProgress> The Migration is under
              process
            </div>
          )}
          {isFailed && (
            <div className='mt-1'>
              <b className='text-red-600'>Note : </b>Migration failed during{' '}
              <b>{isFailed.split(' to ').join('  —>  ')}</b>. So migration
              rolled back automatically.
            </div>
          )}
          <div className='mt-2 text-end'>
            <Button
              variant='contained'
              color='success'
              className='ml-4'
              onClick={() => setOpen(false)}
            >
              OK
            </Button>
          </div>
        </div>
      </ModalDialog>
    </div>
  );
};
